import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="app-shell flex items-center justify-center">
        <div className="text-brand-tan tracking-[0.4em] text-xs">
          ARISTEIA
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

export default ProtectedRoute;
